import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { UnidadMedidaService } from '../../../services/formulacion/unidad-medida.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
declare const toastr: any;
@Component({
  selector: 'app-unidad-medida',
  templateUrl: './unidad-medida.component.html',
  styleUrls: [],
  providers: [UnidadMedidaService]
})
export class UnidadMedidaComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  dataResourceUM: any[];
  model: any = {
    id: 0,
    denominacion: '',
    descripcion: '',
    es_habilitado: true
  };
  fuenteId: number;
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  state_toogle: boolean = false;
  vigencia: any[];
  baseUrl = environment.apiEndpoint;
  hasError: any;
  tipo_agregacion_id: number = 1;;
  unidad_organizacional_id: number = 0;

  constructor(private _us: UnidadMedidaService) {
    this.vigencia = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];
    this.clearErrors();
    this.getUnidadesMedida();
    let u = JSON.parse(localStorage.getItem('u'));        
    this.tipo_agregacion_id = 1;  
    this.unidad_organizacional_id = u.unidad; 
  }

  ngOnInit() {
  }

  clearErrors() {
    this.hasError = { denominacion: false, descripcion: false };
  }

  getUnidadesMedida() {
    this._us.getUnidadMedida().subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceUM = result.data;
        } else {
          this.dataResourceUM = [];
        }
      },
      error => {
        console.log('Error', error);
      });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  showModalAdd() {
    this.clearErrors();
    this.model.id = 0;
    this.model.denominacion = '';
    this.model.descripcion = '';
    this.model.es_habilitado = '';
    this.state_toogle = false;
    this.popupVisibleAdd = true;
  }

  showModalEdit(data: any) {
    this.clearErrors();
    this.model.id = data.id;
    this.model.denominacion = data.denominacion;
    this.model.descripcion = data.descripcion;
    this.model.es_habilitado = data.es_habilitado;
    this.state_toogle = true;
    this.popupVisibleAdd = true;
  }

  saveUnidadMedida() {
    console.log(":::",this.model);
    this.hasError = { denominacion: false, descripcion: false };
    if (this.validate(this.model)) {
      if (this.model.id == 0) {
        this._us.postUnidadMedida(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getUnidadesMedida();
              this.popupVisibleAdd = false;              
              toastr.success('Datos guardados correctamente.');          
            } else {              
              toastr.warning(result.data);   
            }
          },
          error => { console.log('Error', error); });
      }
      else {
        this._us.putUnidadMedida(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getUnidadesMedida();
              this.popupVisibleAdd = false;              
              toastr.success('Datos Actualizados correctamente.');          
            } else {              
              toastr.warning(result.data);   
            }
          },
          error => { console.log('Error', error); });
      }
    }
  }

  showModalDelete(id: number) {
    this.fuenteId = id;
    this.popupVisibleDel = true;
  }

  deletePartida() {
    this._us.deleteUnidadMedida(this.fuenteId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getUnidadesMedida();
          this.popupVisibleDel = false;          
          toastr.success('Proceso realizado correctamente.');          
        } else {              
          toastr.warning(result.data);   
        }
      },
      error => { console.log('Error', error); });
  }

  validate(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.denominacion, 'text')) {
      this.hasError.denominacion = true; res = false;
    }
    if (!UtilHelper.validator(data.descripcion, 'text')) {
      this.hasError.descripcion = true; res = false;
    }
    return res;
  }
}
